export const itunes_link	= 'https://itunes.apple.com/app/apple-store/id1474684190'
export const g_play_link	= 'https://play.google.com/store/apps/details?id=com.portraitai.portraitai'
export const retouch_link	= 'https://play.google.com/store/apps/details?id=com.advasoft.touchretouch&referrer=utm_source%3Dportraitai'